(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Variable globale pour synchroniser les chevrons mobiles
  let syncMobileSortChevrons;

  (function () {
    const iconButtons = document.querySelectorAll('[data-icon-trigger]');

    iconButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const iconType = this.getAttribute('data-icon-trigger');
        const box = document.querySelector(`[data-icon-box="${iconType}"]`);
        const isActive = this.classList.contains('active');

        // Fermer toutes les autres boxes et boutons
        document.querySelectorAll('[data-icon-trigger]').forEach((btn) => {
          btn.classList.remove('active');
        });
        document.querySelectorAll('[data-icon-box]').forEach((b) => {
          b.classList.remove('active');
        });

        // Toggle la box actuelle
        if (!isActive) {
          this.classList.add('active');
          box.classList.add('active');
        }
      });
    });

    // Fermer les boxes en cliquant en dehors
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.collection__icon-wrapper')) {
        document.querySelectorAll('[data-icon-trigger]').forEach((btn) => {
          btn.classList.remove('active');
        });
        document.querySelectorAll('[data-icon-box]').forEach((box) => {
          box.classList.remove('active');
        });
      }
    });

    // Gestion du filtrage multiple par type de produit
    const productTypeFilters = document.querySelectorAll('.collection__product-type-filter');
    const products = document.querySelectorAll('.collection__product');
    let activeFilters = new Set();
    let activeArtists = new Set();
    let activeRarities = new Set();

    // Log tous les types de produits disponibles et tous les filtres disponibles
    console.log('📊 [DEBUG] Available product types in DOM:');
    const availableTypes = new Set();
    products.forEach(product => {
      const type = product.getAttribute('data-product-type');
      availableTypes.add(type);
    });
    console.log('📊 [DEBUG] Unique product types:', Array.from(availableTypes));

    console.log('📊 [DEBUG] Available filter buttons:');
    productTypeFilters.forEach(filter => {
      console.log('   -', filter.getAttribute('data-product-type'));
    });

    // Initialiser les filtres depuis l'URL au chargement de la page
    function initializeFiltersFromURL() {
      console.log('🔷 [INIT] initializeFiltersFromURL called');
      const urlParams = new URLSearchParams(window.location.search);
      const productTypeParam = urlParams.get('filter.p.product_type');
      console.log('🔷 [INIT] URL params:', window.location.search);
      console.log('🔷 [INIT] Product type from URL:', productTypeParam);

      if (productTypeParam) {
        // Ajouter le type de produit au Set des filtres actifs
        activeFilters.add(productTypeParam);
        console.log('🔷 [INIT] activeFilters after adding from URL:', Array.from(activeFilters));

        // Activer le bouton de filtre correspondant (desktop et mobile)
        productTypeFilters.forEach((filter) => {
          if (filter.getAttribute('data-product-type') === productTypeParam) {
            filter.classList.add('active');
            console.log('🔷 [INIT] Activated filter button:', filter.getAttribute('data-product-type'));
          }
        });

        // Activer les filtres mobiles correspondants
        const mobileProductTypeBtns = document.querySelectorAll('.collection__mobile-product-type');
        mobileProductTypeBtns.forEach((btn) => {
          if (btn.getAttribute('data-product-type') === productTypeParam) {
            btn.classList.add('active');
          }
        });

        // Mettre à jour l'état de l'icône Masterpieces
        const masterpiecesButton = document.querySelector('[data-icon-trigger="masterpieces"]');
        if (masterpiecesButton) {
          masterpiecesButton.classList.add('filtered');
        }

        // Filtrer les produits
        console.log('🔷 [INIT] Calling filterProducts()');
        filterProducts();

        // Nettoyer l'URL pour ne pas qu'elle interfère avec les futurs filtres
        // On remplace l'URL sans les paramètres de filtre, sans recharger la page
        const cleanUrl = window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
        console.log('🔷 [INIT] URL cleaned to:', cleanUrl);
        console.log('🔷 [INIT] activeFilters after init:', Array.from(activeFilters));
      } else {
        console.log('🔷 [INIT] No URL filter found');
      }
    }

    // Appeler l'initialisation au chargement
    initializeFiltersFromURL();

    // Fonction pour filtrer les produits par artistes, types et raretés
    function filterProductsByArtists() {
      console.log('🔶 [FILTER] filterProductsByArtists called');
      console.log('🔶 [FILTER] activeFilters:', Array.from(activeFilters));
      console.log('🔶 [FILTER] activeArtists:', Array.from(activeArtists));
      console.log('🔶 [FILTER] activeRarities:', Array.from(activeRarities));

      if (activeArtists.size === 0 && activeFilters.size === 0 && activeRarities.size === 0) {
        // Aucun filtre actif : afficher tous les produits
        console.log('🔶 [FILTER] No filters active, showing all products');
        products.forEach((product) => {
          product.classList.remove('hidden');
        });
      } else {
        // Filtres actifs : combiner les filtres de type, artiste et rareté
        console.log('🔶 [FILTER] Filters active, filtering products...');
        let visibleCount = 0;
        let hiddenCount = 0;

        products.forEach((product) => {
          const productType = product.getAttribute('data-product-type');
          const productArtist = product.getAttribute('data-product-artist');
          const productRarity = product.getAttribute('data-product-rarity');

          let showProduct = true;

          // Si un filtre de type est actif, le produit doit correspondre
          if (activeFilters.size > 0) {
            showProduct = activeFilters.has(productType);
            console.log(`🔶 [FILTER] Product type: ${productType}, matches filter: ${showProduct}`);
          }

          // Si un filtre d'artiste est actif, le produit doit correspondre
          if (activeArtists.size > 0 && showProduct) {
            showProduct = activeArtists.has(productArtist);
          }

          // Si un filtre de rareté est actif, le produit doit correspondre
          if (activeRarities.size > 0 && showProduct) {
            showProduct = activeRarities.has(productRarity);
          }

          if (showProduct) {
            product.classList.remove('hidden');
            visibleCount++;
          } else {
            product.classList.add('hidden');
            hiddenCount++;
          }
        });

        console.log(`🔶 [FILTER] Results: ${visibleCount} visible, ${hiddenCount} hidden`);
      }
    }

    // Fonction pour filtrer les produits (délègue à filterProductsByArtists)
    function filterProducts() {
      filterProductsByArtists();
    }

    productTypeFilters.forEach((filter) => {
      filter.addEventListener('click', function (event) {
        event.stopPropagation();

        const productType = this.getAttribute('data-product-type');
        console.log('🔵 [CLICK] Filter clicked:', productType);
        console.log('🔵 [CLICK] activeFilters before toggle:', Array.from(activeFilters));

        // Toggle le filtre
        if (activeFilters.has(productType)) {
          activeFilters.delete(productType);
          this.classList.remove('active');
          console.log('🔵 [CLICK] Removed filter:', productType);
        } else {
          activeFilters.add(productType);
          this.classList.add('active');
          console.log('🔵 [CLICK] Added filter:', productType);
        }

        console.log('🔵 [CLICK] activeFilters after toggle:', Array.from(activeFilters));

        // Mettre à jour tous les filtres avec le même type (desktop et mobile)
        productTypeFilters.forEach((f) => {
          if (f.getAttribute('data-product-type') === productType) {
            if (activeFilters.has(productType)) {
              f.classList.add('active');
            } else {
              f.classList.remove('active');
            }
          }
        });

        // Mettre à jour les filtres mobiles
        const mobileProductTypeBtns = document.querySelectorAll('.collection__mobile-product-type');
        mobileProductTypeBtns.forEach((btn) => {
          if (btn.getAttribute('data-product-type') === productType) {
            if (activeFilters.has(productType)) {
              btn.classList.add('active');
            } else {
              btn.classList.remove('active');
            }
          }
        });

        // Mettre à jour l'état de l'icône Masterpieces uniquement
        const masterpiecesButton = document.querySelector('[data-icon-trigger="masterpieces"]');
        if (activeFilters.size === 0) {
          masterpiecesButton.classList.remove('filtered');
        } else {
          masterpiecesButton.classList.add('filtered');
        }

        // Filtrer les produits
        console.log('🔵 [CLICK] Calling filterProducts()');
        filterProducts();
      });
    });

    // Gestion du clic sur le badge de suppression des filtres Masterpieces
    const masterpiecesButton = document.querySelector('[data-icon-trigger="masterpieces"]');
    const deleteFilterBadge = masterpiecesButton?.querySelector('.collection__delete-filter-badge');
    if (deleteFilterBadge) {
      deleteFilterBadge.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();

        console.log('🔴 [DELETE] Delete badge clicked');
        console.log('🔴 [DELETE] activeFilters before clear:', Array.from(activeFilters));

        // Désactiver tous les filtres
        activeFilters.clear();
        productTypeFilters.forEach((f) => f.classList.remove('active'));

        // Désactiver les filtres mobiles
        const mobileProductTypeBtns = document.querySelectorAll('.collection__mobile-product-type');
        mobileProductTypeBtns.forEach((btn) => btn.classList.remove('active'));

        // Retirer la classe filtered de l'icône Masterpieces
        masterpiecesButton.classList.remove('filtered');

        console.log('🔴 [DELETE] activeFilters after clear:', Array.from(activeFilters));
        console.log('🔴 [DELETE] Calling filterProducts()');

        // Réafficher tous les produits
        filterProducts();
      });
    }

    // Gestion du filtrage par artistes
    const artistSearch = document.querySelector('[data-artist-search]');
    const artistCheckboxes = document.querySelectorAll('[data-artist-filter]');
    const artistLabels = document.querySelectorAll('.collection__artist-checkbox-label');

    // Recherche d'artiste dans le textfield
    if (artistSearch) {
      artistSearch.addEventListener('input', function () {
        const searchTerm = this.value.toLowerCase();

        artistLabels.forEach((label) => {
          const artistName = label.querySelector('.collection__artist-name-label').textContent.toLowerCase();
          if (artistName.includes(searchTerm)) {
            label.classList.remove('hidden');
          } else {
            label.classList.add('hidden');
          }
        });
      });
    }

    // Filtrage par checkbox d'artiste
    artistCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', function () {
        const artistValue = this.value;

        if (this.checked) {
          activeArtists.add(artistValue);
        } else {
          activeArtists.delete(artistValue);
        }

        // Mettre à jour l'état de l'icône Artists
        const artistsButton = document.querySelector('[data-icon-trigger="artists"]');
        if (activeArtists.size === 0) {
          artistsButton.classList.remove('filtered');
        } else {
          artistsButton.classList.add('filtered');
        }

        // Mettre à jour le filtrage des produits
        filterProductsByArtists();
      });
    });

    // Gestion du clic sur le badge de suppression des filtres d'artistes
    const artistsButton = document.querySelector('[data-icon-trigger="artists"]');
    const deleteArtistFilterBadge = artistsButton.querySelector('.collection__delete-filter-badge');
    if (deleteArtistFilterBadge) {
      deleteArtistFilterBadge.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();

        // Désactiver tous les filtres d'artistes
        activeArtists.clear();
        artistCheckboxes.forEach((cb) => (cb.checked = false));

        // Retirer la classe filtered de l'icône Artists
        artistsButton.classList.remove('filtered');

        // Réafficher les produits filtrés
        filterProductsByArtists();
      });
    }

    // Gestion du filtrage par rareté
    const rarityFilters = document.querySelectorAll('.collection__rarity-filter');

    rarityFilters.forEach((filter) => {
      filter.addEventListener('click', function (event) {
        event.stopPropagation();

        const rarity = this.getAttribute('data-rarity');

        // Toggle le filtre
        if (activeRarities.has(rarity)) {
          activeRarities.delete(rarity);
          this.classList.remove('active');
        } else {
          activeRarities.add(rarity);
          this.classList.add('active');
        }

        // Mettre à jour les filtres mobiles de rareté
        const mobileRarityBtns = document.querySelectorAll('.collection__mobile-rarity');
        mobileRarityBtns.forEach((btn) => {
          if (btn.getAttribute('data-rarity') === rarity) {
            if (activeRarities.has(rarity)) {
              btn.classList.add('active');
            } else {
              btn.classList.remove('active');
            }
          }
        });

        // Mettre à jour l'état de l'icône Rarities
        const raritiesButton = document.querySelector('[data-icon-trigger="rarities"]');
        if (activeRarities.size === 0) {
          raritiesButton.classList.remove('filtered');
        } else {
          raritiesButton.classList.add('filtered');
        }

        // Mettre à jour le filtrage des produits
        filterProductsByArtists();
      });
    });

    // Gestion du clic sur le badge de suppression des filtres de rareté
    const raritiesButton = document.querySelector('[data-icon-trigger="rarities"]');
    const deleteRarityFilterBadge = raritiesButton.querySelector('.collection__delete-filter-badge');
    if (deleteRarityFilterBadge) {
      deleteRarityFilterBadge.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();

        // Désactiver tous les filtres de rareté
        activeRarities.clear();
        rarityFilters.forEach((f) => f.classList.remove('active'));

        // Désactiver les filtres mobiles de rareté
        const mobileRarityBtns = document.querySelectorAll('.collection__mobile-rarity');
        mobileRarityBtns.forEach((btn) => btn.classList.remove('active'));

        // Retirer la classe filtered de l'icône Rarities
        raritiesButton.classList.remove('filtered');

        // Réafficher les produits filtrés
        filterProductsByArtists();
      });
    }

    // Gestion du menu de tri
    const settingsBtn = document.querySelector('[data-settings-btn]');
    const settingsMenu = document.querySelector('[data-settings-menu]');

    if (settingsBtn && settingsMenu) {
      settingsBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        settingsMenu.classList.toggle('is-open');
        settingsBtn.classList.toggle('is-active');
      });

      // Fermer le menu si on clique ailleurs
      document.addEventListener('click', function () {
        settingsMenu.classList.remove('is-open');
        settingsBtn.classList.remove('is-active');
      });

      // Empêcher la fermeture si on clique sur le menu
      settingsMenu.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    // Gestion du tri par options
    const sortOptions = document.querySelectorAll('.collection__settings-option');
    const productGrid = document.querySelector('.collection__grid');
    let currentSort = {}; // { type: 'price'|'rarity'|'az', direction: 'down'|'up' }

    // Sauvegarder l'ordre initial des produits au chargement de la page
    let initialProductOrder = [];
    if (productGrid) {
      initialProductOrder = Array.from(productGrid.querySelectorAll('.collection__product'));
    }

    sortOptions.forEach((option) => {
      option.addEventListener('click', function (event) {
        event.stopPropagation();

        const sortType = this.getAttribute('data-sort');
        const chevronUp = this.querySelector('.collection__settings-chevron--up');
        const chevronDown = this.querySelector('.collection__settings-chevron--down');

        // Vérifier l'état actuel de cette option
        const hasActiveChevron =
          chevronUp.classList.contains('is-active') || chevronDown.classList.contains('is-active');

        if (!hasActiveChevron) {
          // Premier clic : activer chevron down (par défaut)
          // Désactiver tous les autres chevrons
          sortOptions.forEach((opt) => {
            opt.querySelectorAll('.collection__settings-chevron').forEach((c) => c.classList.remove('is-active'));
          });

          chevronDown.classList.add('is-active');
          currentSort = { type: sortType, direction: 'down' };
        } else if (chevronDown.classList.contains('is-active')) {
          // Deuxième clic : passer à chevron up
          chevronDown.classList.remove('is-active');
          chevronUp.classList.add('is-active');
          currentSort = { type: sortType, direction: 'up' };
        } else {
          // Troisième clic : revenir à chevron down
          chevronUp.classList.remove('is-active');
          chevronDown.classList.add('is-active');
          currentSort = { type: sortType, direction: 'down' };
        }

        // Synchroniser les chevrons mobiles
        syncMobileSortChevrons();

        // Trier les produits
        sortProducts(currentSort);
      });
    });

    // Fonction pour synchroniser les chevrons mobiles avec les chevrons desktop
    syncMobileSortChevrons = function () {
      // Désactiver tous les chevrons mobiles
      const allMobileChevrons = document.querySelectorAll('.collection__mobile-sort-chevron');
      allMobileChevrons.forEach((c) => c.classList.remove('active'));

      // Activer le chevron mobile correspondant au chevron desktop actif
      sortOptions.forEach((option) => {
        const sortType = option.getAttribute('data-sort');
        const chevronUp = option.querySelector('.collection__settings-chevron--up');
        const chevronDown = option.querySelector('.collection__settings-chevron--down');

        if (chevronUp.classList.contains('is-active')) {
          const mobileOption = document.querySelector(`[data-mobile-sort="${sortType}"]`);
          if (mobileOption) {
            const mobileChevronUp = mobileOption.querySelector('.collection__mobile-sort-chevron--up');
            if (mobileChevronUp) {
              mobileChevronUp.classList.add('active');
            }
          }
        } else if (chevronDown.classList.contains('is-active')) {
          const mobileOption = document.querySelector(`[data-mobile-sort="${sortType}"]`);
          if (mobileOption) {
            const mobileChevronDown = mobileOption.querySelector('.collection__mobile-sort-chevron--down');
            if (mobileChevronDown) {
              mobileChevronDown.classList.add('active');
            }
          }
        }
      });
    };

    function sortProducts(sort) {
      if (!productGrid) return;

      let products = [];

      if (!sort) {
        // Pas de tri, rétablir l'ordre original sauvegardé au chargement
        products = [...initialProductOrder];
      } else {
        products = Array.from(productGrid.querySelectorAll('.collection__product'));
        products.sort((a, b) => {
          let compareValue = 0;

          switch (sort.type) {
            case 'price':
              const priceA = parseFloat(a.getAttribute('data-product-price'));
              const priceB = parseFloat(b.getAttribute('data-product-price'));
              compareValue = priceA - priceB;
              break;

            case 'rarity':
              const rarityOrder = { legendary: 4, epic: 3, rare: 2, common: 1 };
              const rarityA = rarityOrder[a.getAttribute('data-product-rarity')] || 0;
              const rarityB = rarityOrder[b.getAttribute('data-product-rarity')] || 0;
              compareValue = rarityA - rarityB;
              break;

            case 'az':
              const titleA = a.getAttribute('data-product-title') || '';
              const titleB = b.getAttribute('data-product-title') || '';
              compareValue = titleA.localeCompare(titleB);
              break;
          }

          // Inverser si direction down
          return sort.direction === 'down' ? compareValue : -compareValue;
        });
      }

      // Réorganiser le DOM
      products.forEach((product) => {
        productGrid.appendChild(product);
      });

      // Mettre à jour la classe du bouton de tri
      updateSortButtonState();
    }

    // Mettre à jour l'état du bouton de tri
    function updateSortButtonState() {
      const settingsBtn = document.querySelector('[data-settings-btn]');
      if (!settingsBtn) return;

      const hasActiveSort =
        sortOptions &&
        Array.from(sortOptions).some((opt) => {
          const chevronUp = opt.querySelector('.collection__settings-chevron--up');
          const chevronDown = opt.querySelector('.collection__settings-chevron--down');
          return chevronUp?.classList.contains('is-active') || chevronDown?.classList.contains('is-active');
        });

      if (hasActiveSort) {
        settingsBtn.classList.add('has-active-sort');
      } else {
        settingsBtn.classList.remove('has-active-sort');
      }
    }

    // Gérer le clic sur le badge de suppression du tri (desktop)
    const clearSortBadge = document.querySelector('[data-clear-sort]');
    if (clearSortBadge) {
      clearSortBadge.addEventListener('click', function (event) {
        event.stopPropagation();

        // Désactiver tous les chevrons
        sortOptions.forEach((opt) => {
          opt.querySelectorAll('.collection__settings-chevron').forEach((c) => c.classList.remove('is-active'));
        });

        // Synchroniser les chevrons mobiles
        syncMobileSortChevrons();

        // Réinitialiser le tri
        currentSort = {};
        sortProducts(null);

        // Mettre à jour l'état du bouton
        updateSortButtonState();
      });
    }

    // Appeler updateSortButtonState et syncMobileSortChevrons au chargement
    updateSortButtonState();
    syncMobileSortChevrons();
  })();
(function () {
  const productGrid = document.querySelector('.collection__grid');
  
  if (productGrid && !window.location.search.includes('filter')) {
    // Ne trier que si aucun filtre URL n'est présent
    const products = Array.from(productGrid.querySelectorAll('.collection__product'));
    
    // Trier par date de création (timestamp décroissant)
    products.sort((a, b) => {
      const dateA = parseInt(a.getAttribute('data-created-at') || '0');
      const dateB = parseInt(b.getAttribute('data-created-at') || '0');
      return dateB - dateA; // Plus récent en premier
    });
    
    // Réorganiser le DOM
    products.forEach(product => {
      productGrid.appendChild(product);
    });
    
    console.log('✅ Products sorted by creation date (newest first)');
  }
})();
  // Mobile Filter Bar
  (function () {
    const mobileFilterBtns = document.querySelectorAll('[data-mobile-filter]');
    const mobilePanels = document.querySelectorAll('[data-mobile-panel]');
    const panelCloses = document.querySelectorAll('[data-panel-close]');
    const backdrop = document.querySelector('[data-mobile-filter-backdrop]');

    function closePanels() {
      mobilePanels.forEach((p) => p.classList.remove('active'));
      mobileFilterBtns.forEach((b) => b.classList.remove('active'));
      if (backdrop) {
        backdrop.classList.remove('active');
      }
    }

    // Open panel on filter button click
    mobileFilterBtns.forEach((btn) => {
      btn.addEventListener('click', function () {
        const filterType = this.getAttribute('data-mobile-filter');
        const targetPanel = document.querySelector(`[data-mobile-panel="${filterType}"]`);

        // Close all panels first
        closePanels();

        // Open target panel
        if (targetPanel) {
          targetPanel.classList.add('active');
          if (backdrop) {
            backdrop.classList.add('active');
          }
        }

        // Toggle active state on buttons
        this.classList.add('active');
      });
    });

    // Close panel on X button click
    panelCloses.forEach((closeBtn) => {
      closeBtn.addEventListener('click', function () {
        closePanels();
      });
    });

    // Close panel on backdrop click
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        closePanels();
      });
    }

    // Mobile Product Type filters
    const mobileProductTypeBtns = document.querySelectorAll('.collection__mobile-product-type');
    mobileProductTypeBtns.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        const productType = this.getAttribute('data-product-type');
        const desktopBtn = document.querySelector(
          `.collection__product-type-filter[data-product-type="${productType}"]`
        );

        if (desktopBtn) {
          desktopBtn.click();
        }

        this.classList.toggle('active');
        updateFilterBarButtons();
      });
    });

    // Mobile Rarity filters
    const mobileRarityBtns = document.querySelectorAll('.collection__mobile-rarity');
    mobileRarityBtns.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        const rarity = this.getAttribute('data-rarity');
        const desktopBtn = document.querySelector(`.collection__rarity-filter[data-rarity="${rarity}"]`);

        if (desktopBtn) {
          desktopBtn.click();
        }

        this.classList.toggle('active');
        updateFilterBarButtons();
      });
    });

    // Mobile Artist filters
    const mobileArtistCheckboxes = document.querySelectorAll('[data-mobile-artist-filter]');
    mobileArtistCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', function () {
        const artist = this.value;
        const desktopCheckbox = document.querySelector(`.collection__artist-checkbox[value="${artist}"]`);

        if (desktopCheckbox) {
          desktopCheckbox.checked = this.checked;
          desktopCheckbox.dispatchEvent(new Event('change'));
        }
        updateFilterBarButtons();
      });
    });

    // Mobile Artist Search
    const mobileArtistSearch = document.querySelector('[data-mobile-artist-search]');
    if (mobileArtistSearch) {
      mobileArtistSearch.addEventListener('input', function () {
        const searchTerm = this.value.toLowerCase();
        const artistItems = document.querySelectorAll('.collection__mobile-artist-item');

        artistItems.forEach((item) => {
          const artistName = item.textContent.toLowerCase();
          if (artistName.includes(searchTerm)) {
            item.style.display = 'flex';
          } else {
            item.style.display = 'none';
          }
        });
      });
    }

    // Mobile Sort options
    const mobileSortOptions = document.querySelectorAll('[data-mobile-sort]');
    mobileSortOptions.forEach((option) => {
      option.addEventListener('click', function () {
        const sortType = this.getAttribute('data-mobile-sort');
        const desktopSortOption = document.querySelector(`.collection__settings-option[data-sort="${sortType}"]`);

        if (desktopSortOption) {
          desktopSortOption.click();
        }
        updateFilterBarButtons();
      });
    });

    // Mobile Clear Filters buttons (on the filter bar buttons)
    const mobileClearBarBtns = document.querySelectorAll('[data-mobile-clear-bar]');
    mobileClearBarBtns.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        const clearType = this.getAttribute('data-mobile-clear-bar');

        if (clearType === 'masterpieces') {
          // Clear all product type filters
          const desktopClearBadge = document.querySelector(
            '[data-icon-trigger="masterpieces"] .collection__delete-filter-badge'
          );
          if (desktopClearBadge) {
            desktopClearBadge.click();
          }
        } else if (clearType === 'artists') {
          // Clear all artist filters
          const desktopClearBadge = document.querySelector(
            '[data-icon-trigger="artists"] .collection__delete-filter-badge'
          );
          if (desktopClearBadge) {
            desktopClearBadge.click();
          }
        } else if (clearType === 'rarities') {
          // Clear all rarity filters
          const desktopClearBadge = document.querySelector(
            '[data-icon-trigger="rarities"] .collection__delete-filter-badge'
          );
          if (desktopClearBadge) {
            desktopClearBadge.click();
          }
        } else if (clearType === 'sort') {
          // Clear sorting
          const desktopClearSort = document.querySelector('[data-clear-sort]');
          if (desktopClearSort) {
            desktopClearSort.click();
          }
        }

        updateFilterBarButtons();
      });
    });

    // Function to update filter bar buttons state
    function updateFilterBarButtons() {
      // Update Masterpieces button
      const masterpiecesBtn = document.querySelector('[data-filter-type="masterpieces"]');
      const activeProductTypes = document.querySelectorAll('.collection__mobile-product-type.active');
      if (masterpiecesBtn) {
        if (activeProductTypes.length > 0) {
          masterpiecesBtn.classList.add('has-filters');
        } else {
          masterpiecesBtn.classList.remove('has-filters');
        }
      }

      // Update Artists button
      const artistsBtn = document.querySelector('[data-filter-type="artists"]');
      const activeArtists = document.querySelectorAll('[data-mobile-artist-filter]:checked');
      if (artistsBtn) {
        if (activeArtists.length > 0) {
          artistsBtn.classList.add('has-filters');
        } else {
          artistsBtn.classList.remove('has-filters');
        }
      }

      // Update Rarities button
      const raritiesBtn = document.querySelector('[data-filter-type="rarities"]');
      const activeRarities = document.querySelectorAll('.collection__mobile-rarity.active');
      if (raritiesBtn) {
        if (activeRarities.length > 0) {
          raritiesBtn.classList.add('has-filters');
        } else {
          raritiesBtn.classList.remove('has-filters');
        }
      }

      // Update Sort button
      const sortBtn = document.querySelector('[data-filter-type="sort"]');
      const activeChevrons = document.querySelectorAll('.collection__mobile-sort-chevron.active');
      if (sortBtn) {
        if (activeChevrons.length > 0) {
          sortBtn.classList.add('has-filters');
        } else {
          sortBtn.classList.remove('has-filters');
        }
      }
    }

    // Initial update
    updateFilterBarButtons();
  })();

  // Auto-open Masterpieces filter on page load
  (function () {
    function autoOpenMasterpieces() {
      const masterpiecesTrigger = document.querySelector('[data-icon-trigger="masterpieces"]');
      const masterpiecesBox = document.querySelector('[data-icon-box="masterpieces"]');

      if (masterpiecesTrigger && masterpiecesBox) {
        masterpiecesTrigger.classList.add('active');
        masterpiecesBox.classList.add('active');
      }
    }

    // Call on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autoOpenMasterpieces);
    } else {
      autoOpenMasterpieces();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SideNavigation {
    constructor() {
      this.sideNav = document.querySelector('[data-side-nav]');
      this.overlay = document.querySelector('[data-side-nav-overlay]');
      this.triggers = document.querySelectorAll('[data-side-nav-trigger]');
      this.closeBtn = document.querySelector('[data-side-nav-close]');
      this.scrollStar = document.querySelector('[data-scroll-star]');
      this.content = this.sideNav?.querySelector('.side-nav__content');
      this.preview = document.querySelector('[data-side-nav-preview]');
      this.previewCloseBtn = document.querySelector('[data-preview-close]');
      this.previewOpenBtn = document.querySelector('[data-preview-open]');
      this.previewItems = document.querySelectorAll('[data-preview-item]');

      // Preview state
      this.previewManuallyClosed = false;

      // Menu title to product type mapping
      this.menuToTypeMapping = {
        'posters': 'poster',
        'keycaps': 'keycaps',
        'tapis-de-souris': 'mousepad'
      };

      // Load products data
      this.productsData = this.loadProductsData();

      if (
        this.sideNav &&
        this.overlay &&
        this.triggers.length > 0 &&
        this.closeBtn &&
        this.scrollStar &&
        this.preview
      ) {
        this.init();
      }
    }

    loadProductsData() {
      const dataScript = document.getElementById('preview-products-data');

      try {
        if (!dataScript) {
          console.warn('⚠️ Preview products data script not found');
          return {};
        }

        const rawContent = dataScript.textContent.trim();

        const data = JSON.parse(rawContent);
        return data;
      } catch (error) {
        console.error('❌ Error loading products data:', error);
        console.error('Raw content:', dataScript?.textContent);
        return {};
      }
    }

    init() {
      this.bindEvents();
      this.initCustomScrollbar();
      this.initPreviewEvents();
      this.initImageLightEffect();
    }

    initCustomScrollbar() {
      if (!this.content) return;

      // Update star position on scroll
      this.content.addEventListener('scroll', () => {
        this.updateStarPosition();
      });

      // Initial position
      this.updateStarPosition();
    }

    updateStarPosition() {
      if (!this.content) return;

      const scrollTop = this.content.scrollTop;
      const scrollHeight = this.content.scrollHeight;
      const clientHeight = this.content.clientHeight;

      // Calculate maximum scroll
      const maxScroll = scrollHeight - clientHeight;

      if (maxScroll <= 0) {
        // No scroll needed, keep star at top
        this.scrollStar.style.top = '0px';
        return;
      }

      // Calculate percentage of scroll
      const scrollPercent = scrollTop / maxScroll;

      // Calculate available space for star movement (subtract star height)
      const availableHeight = clientHeight - 50; // 50px is star height

      // Calculate star position
      const starPosition = scrollPercent * availableHeight;

      this.scrollStar.style.top = `${starPosition}px`;
    }

    bindEvents() {
      // Open side navigation - bind to all triggers
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.open(trigger));
      });

      // Close side navigation
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());

      // Close preview
      if (this.previewCloseBtn) {
        this.previewCloseBtn.addEventListener('click', () => this.hidePreview());
      }

      // Open preview
      if (this.previewOpenBtn) {
        this.previewOpenBtn.addEventListener('click', () => this.openPreview());
      }

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });
    }

    open(trigger) {
      this.sideNav.classList.add('is-active');
      this.overlay.classList.add('is-active');
      document.body.classList.add('side-nav-open');

      // Set aria-expanded on all triggers
      this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));

      // Store the trigger that opened the nav for focus return
      this.activeTrigger = trigger;

      // Focus trap - focus on close button
      this.closeBtn.focus();
    }

    close() {
      this.sideNav.classList.remove('is-active');
      this.overlay.classList.remove('is-active');
      document.body.classList.remove('side-nav-open');

      // Set aria-expanded on all triggers
      this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));

      // Hide preview when closing sidenav (automatic close, not manual)
      this.hidePreview(false);

      // Réinitialiser l'état pour la prochaine ouverture du side-nav
      this.previewManuallyClosed = false;

      // Return focus to the trigger that opened it
      if (this.activeTrigger) {
        this.activeTrigger.focus();
      }
    }

    isOpen() {
      return this.sideNav.classList.contains('is-active');
    }

    initPreviewEvents() {
      this.previewItems.forEach((item) => {
        item.addEventListener('mouseenter', (e) => this.showPreview(e.target));
      });
    }

    initImageLightEffect() {
      // Add mouse move event to all preview image wrappers for light effect only
      this.preview.addEventListener('mousemove', (e) => {
        const wrappers = this.preview.querySelectorAll('.side-nav__preview-item .image-wrapper');

        wrappers.forEach((wrapper) => {
          const rect = wrapper.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;

          // Check if mouse is over this specific wrapper
          if (x >= 0 && x <= rect.width && y >= 0 && y <= rect.height) {
            // Update light position using CSS custom properties
            wrapper.style.setProperty('--light-x', x + 'px');
            wrapper.style.setProperty('--light-y', y + 'px');
            wrapper.classList.add('light-active');
          } else {
            // Remove light effect when mouse is not over the wrapper
            wrapper.classList.remove('light-active');
          }
        });
      });

      // Remove effects when mouse leaves preview area
      this.preview.addEventListener('mouseleave', () => {
        const wrappers = this.preview.querySelectorAll('.side-nav__preview-item .image-wrapper');
        wrappers.forEach((wrapper) => {
          wrapper.classList.remove('light-active');
        });
      });
    }

    showPreview(item) {
      console.log('🔍 Show preview called - isOpen:', this.isOpen());
      if (!this.isOpen()) return;

      // Don't show preview on mobile (screen width <= 768px)
      if (window.innerWidth <= 768) {
        console.log('📱 Mobile detected, preview disabled');
        return;
      }

      // Ne pas ouvrir le drawer si il a été fermé manuellement
      if (this.previewManuallyClosed) return;

      const itemTitle = item.textContent.trim();
      let tag = item.dataset.tag;
      const previewContent = this.preview.querySelector('.side-nav__preview-content');

      // Apply mapping if exists
      if (this.menuToTypeMapping[tag]) {
        tag = this.menuToTypeMapping[tag];
        console.log('📋 Mapped tag:', item.dataset.tag, '→', tag);
      }

      console.log('  - Title:', itemTitle);
      console.log('  - Tag:', tag);
      console.log('  - Data for this tag:', this.productsData[tag]);

      // Check if there are products to display
      const tagData = this.productsData[tag];
      if (!tagData || !tagData.products || tagData.products.length === 0) {
        console.log('⚠️ No products found for this tag, not opening preview');
        // If preview is already open, close it automatically (not manually)
        if (this.preview.classList.contains('is-active')) {
          this.hidePreview(false); // false = fermeture automatique
        }
        // Don't open preview if no products
        return;
      }

      // First, show the preview zone if not already visible
      if (!this.preview.classList.contains('is-active')) {
        this.preview.classList.add('is-active');

        // Load content
        const html = this.generateProductsHTML(itemTitle, tag);
        previewContent.innerHTML = html;

        // Fade in with a small delay
        setTimeout(() => {
          previewContent.classList.add('is-loaded');
          this.animatePreviewItems(previewContent);
        }, 100);
        return;
      }

      // Fade out current content
      previewContent.classList.remove('is-loaded');

      // Update content after fade out
      setTimeout(() => {
        const html = this.generateProductsHTML(itemTitle, tag);
        previewContent.innerHTML = html;

        // Fade in new content
        setTimeout(() => {
          previewContent.classList.add('is-loaded');
          this.animatePreviewItems(previewContent);
        }, 100);
      }, 300); // Duration of fade out
    }

    generateProductsHTML(title, tag) {
      // Get products for this tag from the data structure
      const tagData = this.productsData[tag];

      if (!tagData || !tagData.products || tagData.products.length === 0) {
        return `
          <div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #f6f6f6; opacity: 0.7; text-align: center; padding: 2rem;">
            <p style="font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; font-size: 14px; line-height: 1.6;">Aucun élément correspondant</p>
          </div>
        `;
      }

      // Get only the 2 most recent products
      const filteredProducts = tagData.products.slice(0, 2);
      console.log('✅ Found products:', filteredProducts);

      const productsHTML = filteredProducts
        .map(
          (product, index) => `
        <div class="side-nav__preview-item" style="margin-bottom: ${
          index === filteredProducts.length - 1 ? '0' : '80px'
        };">
          <a href="${product.url}" style="text-decoration: none; color: inherit; display: block;">
            ${
              product.image
                ? `
              <div class="image-wrapper" data-preview-image-wrapper style="position: relative; display: inline-block; width: 300px; height: 335px;">
                <div class="preview-image-background" style="position: absolute; inset: 0; background-size: cover; background-position: center; filter: blur(20px); opacity: 0; transition: opacity 0.3s ease; border: solid 1px #c6b289;"></div>
                <img src="${product.image}" alt="${product.title}"
                     data-image-width="${product.imageWidth}"
                     data-image-height="${product.imageHeight}"
                     style="width: 300px; height: 335px; object-fit: cover; display: block; position: relative; z-index: 2;">
              </div>
            `
                : ''
            }
          </a>
        </div>
      `
        )
        .join('');

      return `
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; box-sizing: border-box;">
          ${productsHTML}
        </div>
      `;
    }

    animatePreviewItems(previewContent) {
      // Get all preview items and make them visible with opacity
      const items = previewContent.querySelectorAll('.side-nav__preview-item');
      items.forEach((item) => {
        item.classList.add('is-visible');
      });

      // Check image orientation after animation
      this.checkPreviewImageOrientation();
    }

    checkPreviewImageOrientation() {
      const imageWrappers = document.querySelectorAll('[data-preview-image-wrapper]');

      imageWrappers.forEach((wrapper) => {
        const img = wrapper.querySelector('img');
        const background = wrapper.querySelector('.preview-image-background');

        if (!img) return;

        const width = parseInt(img.getAttribute('data-image-width'));
        const height = parseInt(img.getAttribute('data-image-height'));

        // Si l'image est horizontale (largeur > hauteur)
        if (width > height) {
          wrapper.classList.add('image-wrapper--horizontal');
          // Définir l'image de fond
          if (background) {
            background.style.backgroundImage = `url(${img.src})`;
            background.style.opacity = '1';
          }
          img.style.objectFit = 'contain';
        } else {
          wrapper.classList.remove('image-wrapper--horizontal');
          if (background) {
            background.style.opacity = '0';
          }
          img.style.objectFit = 'cover';
        }
      });
    }

    openPreview() {
      if (!this.isOpen()) return;

      // Réinitialiser l'état de fermeture manuelle
      this.previewManuallyClosed = false;

      this.preview.classList.add('is-active');
    }

    hidePreview(isManual = true) {
      const previewContent = this.preview.querySelector('.side-nav__preview-content');

      // Remove is-visible class from all items
      const items = previewContent.querySelectorAll('.side-nav__preview-item');
      items.forEach(item => {
        item.classList.remove('is-visible');
      });

      previewContent.classList.remove('is-loaded');
      this.preview.classList.remove('is-active');

      // Marquer le drawer comme fermé manuellement uniquement si c'est une fermeture manuelle
      if (isManual) {
        this.previewManuallyClosed = true;
      }
    }
  }

  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new SideNavigation();
  });

  // Cart Drawer
  class CartDrawer {
    constructor() {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-drawer-overlay]');
      this.trigger = document.querySelector('[data-cart-drawer-trigger]');
      this.closeBtn = document.querySelector('[data-cart-drawer-close]');
      this.timer = document.querySelector('[data-cart-timer]');

      // Timer variables
      this.timeLeft = 15 * 60; // 15 minutes in seconds
      this.timerInterval = null;

      // Get free shipping threshold from section settings (in euros, convert to cents)
      const header = document.querySelector('header[data-free-shipping-threshold]');
      const thresholdInEuros = header ? parseFloat(header.dataset.freeShippingThreshold) : 51;
      this.freeShippingThreshold = thresholdInEuros * 100; // Convert to cents

      if (this.drawer && this.overlay && this.trigger && this.closeBtn) {
        this.init();
      }
    }

    init() {
      this.bindEvents();
      this.listenForCartUpdates();
      this.updateFreeShippingProgress();
    }

    bindEvents() {
      // Open drawer
      this.trigger.addEventListener('click', () => this.open());

      // Close drawer
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });

      // Quantity buttons
      document.querySelectorAll('[data-qty-increase]').forEach((btn) => {
        btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyIncrease, 1));
      });

      document.querySelectorAll('[data-qty-decrease]').forEach((btn) => {
        btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyDecrease, -1));
      });

      // Remove item buttons
      document.querySelectorAll('[data-remove-item]').forEach((btn) => {
        btn.addEventListener('click', () => this.removeItem(btn.dataset.removeItem));
      });

      // Add to cart buttons in suggestions
      this.bindSuggestionButtons();
    }

    bindSuggestionButtons() {
      document.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
        btn.addEventListener('click', () => this.addToCart(btn.dataset.addToCart));
      });
    }

    open() {
      this.drawer.classList.add('is-active');
      this.overlay.classList.add('is-active');
      document.body.classList.add('cart-drawer-open');
      this.startTimer();
    }

    close() {
      this.drawer.classList.remove('is-active');
      this.overlay.classList.remove('is-active');
      document.body.classList.remove('cart-drawer-open');
      this.stopTimer();
    }

    isOpen() {
      return this.drawer.classList.contains('is-active');
    }

    startTimer() {
      // Reset timer if already running
      if (this.timerInterval) {
        this.stopTimer();
      }

      // Get saved time from localStorage or use default
      const savedTime = localStorage.getItem('cart_timer');
      if (savedTime) {
        this.timeLeft = parseInt(savedTime);
      } else {
        this.timeLeft = 15 * 60; // 15 minutes
      }

      this.updateTimerDisplay();

      this.timerInterval = setInterval(() => {
        this.timeLeft--;

        if (this.timeLeft <= 0) {
          this.stopTimer();
          this.timeLeft = 0;
        }

        this.updateTimerDisplay();
        localStorage.setItem('cart_timer', this.timeLeft);
      }, 1000);
    }

    stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    }

    updateTimerDisplay() {
      const minutes = Math.floor(this.timeLeft / 60);
      const seconds = this.timeLeft % 60;
      const display = `${minutes}:${seconds.toString().padStart(2, '0')}`;

      if (this.timer) {
        this.timer.textContent = display;
      }
    }

    async updateQuantity(key, change) {
      try {
        // Get current quantity
        const itemElement = document.querySelector(`[data-cart-item="${key}"]`);
        const qtyElement = itemElement.querySelector('.cart-drawer__qty-value');
        const currentQty = parseInt(qtyElement.textContent);
        const newQty = currentQty + change;

        // Don't allow quantity to go below 1
        if (newQty < 1) {
          return;
        }

        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: newQty,
          }),
        });

        if (response.ok) {
          const cart = await response.json();

          // Update quantity display
          qtyElement.textContent = newQty;

          // Update cart total
          this.updateCartTotal(cart);

          // Update cart count in header
          this.updateCartCount(cart.item_count);
        }
      } catch (error) {
        console.error('Error updating quantity:', error);
      }
    }

    async removeItem(key) {
      try {
        console.log('removeItem called with key:', key);
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: 0,
          }),
        });

        if (response.ok) {
          const cart = await response.json();
          console.log('Cart after removal:', cart);

          // Remove item from DOM
          const itemElement = document.querySelector(`[data-cart-item="${key}"]`);
          if (itemElement) {
            itemElement.remove();
          }

          // Update cart total
          this.updateCartTotal(cart);

          // Update cart count in header
          this.updateCartCount(cart.item_count);

          // Show empty message if cart is empty
          if (cart.item_count === 0) {
            const itemsContainer = this.drawer.querySelector('.cart-drawer__items');
            itemsContainer.innerHTML = '<p class="cart-drawer__empty">Votre panier est vide</p>';
          }
        }
      } catch (error) {
        console.error('Error removing item:', error);
      }
    }

    async addToCart(variantId) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        });

        if (response.ok) {
          const item = await response.json();

          // Fetch updated cart
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          // Reload drawer content
          await this.reloadDrawerContent();

          // Update cart count in header
          this.updateCartCount(cart.item_count);

          // Update cart total and free shipping progress
          this.updateCartTotal(cart);
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    }

    async reloadDrawerContent() {
      try {
        // Fetch the header section HTML to get updated cart drawer content
        const response = await fetch(window.location.pathname + '?section_id=header');

        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Get the new drawer items
          const newDrawer = doc.querySelector('[data-cart-drawer]');

          if (newDrawer && this.drawer) {
            // Update only the items container
            const newItemsContainer = newDrawer.querySelector('.cart-drawer__items');
            const currentItemsContainer = this.drawer.querySelector('.cart-drawer__items');

            if (newItemsContainer && currentItemsContainer) {
              currentItemsContainer.innerHTML = newItemsContainer.innerHTML;
            }

            // Re-bind quantity and remove buttons
            this.drawer.querySelectorAll('[data-qty-increase]').forEach((btn) => {
              btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyIncrease, 1));
            });

            this.drawer.querySelectorAll('[data-qty-decrease]').forEach((btn) => {
              btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyDecrease, -1));
            });

            this.drawer.querySelectorAll('[data-remove-item]').forEach((btn) => {
              btn.addEventListener('click', () => this.removeItem(btn.dataset.removeItem));
            });
          }
        }
      } catch (error) {
        console.error('Error reloading drawer content:', error);
      }
    }

    updateCartTotal(cart) {
      console.log('updateCartTotal called with cart.total_price:', cart.total_price);
      const totalElement = document.querySelector('[data-cart-total]');
      if (totalElement) {
        // Format price (assuming price is in cents)
        const formattedPrice = (cart.total_price / 100).toFixed(2).replace('.', ',');
        totalElement.textContent = formattedPrice + '€';
      }
      // Update free shipping progress when cart total changes
      this.updateFreeShippingProgress(cart.total_price);
    }

    updateFreeShippingProgress(cartTotal = null) {
      const progressFillEl = document.querySelector('[data-progress-fill]');
      const freeShippingTextEl = document.querySelector('[data-free-shipping-text]');

      if (!progressFillEl || !freeShippingTextEl) {
        console.log('Missing elements, returning early');
        return;
      }

      // Get cart total if not provided
      if (cartTotal === null) {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            this.updateFreeShippingProgressDisplay(
              cart.total_price,
              this.freeShippingThreshold,
              progressFillEl,
              freeShippingTextEl
            );
          })
          .catch((error) => console.error('Error fetching cart:', error));
      } else {
        this.updateFreeShippingProgressDisplay(
          cartTotal,
          this.freeShippingThreshold,
          progressFillEl,
          freeShippingTextEl
        );
      }
    }

    updateFreeShippingProgressDisplay(cartTotal, threshold, progressFillEl, textEl) {
      const remaining = threshold - cartTotal;
      const progressPercentage = Math.min((cartTotal / threshold) * 100, 100);

      if (remaining > 0) {
        const formattedRemaining = (remaining / 100).toFixed(2).replace('.', ',');
        textEl.innerHTML = `Plus que <span data-remaining-amount>${formattedRemaining}</span>€ et la livraison est offerte !`;
      } else {
        textEl.textContent = 'Livraison gratuite offerte !';
      }

      progressFillEl.style.width = `${progressPercentage}%`;
    }

    updateCartCount(count) {
      const cartCount = document.querySelector('[data-cart-count]');
      if (cartCount) {
        cartCount.textContent = count;
        if (count > 0) {
          cartCount.style.display = 'flex';
        } else {
          cartCount.style.display = 'none';
        }
      }
    }

    listenForCartUpdates() {
      document.addEventListener('cart:updated', (event) => {
        const shouldOpen = event.detail?.openDrawer || false;
        this.reloadDrawer(shouldOpen);
      });
    }

    async reloadDrawer(shouldOpen = false) {
      try {
        // Fetch the header section HTML to get updated cart drawer content
        const response = await fetch(window.location.pathname + '?section_id=header');

        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Get the new drawer content
          const newDrawer = doc.querySelector('[data-cart-drawer]');

          if (newDrawer && this.drawer) {
            // Replace the drawer content
            this.drawer.innerHTML = newDrawer.innerHTML;

            // Re-bind events for the new elements
            this.closeBtn = this.drawer.querySelector('[data-cart-drawer-close]');
            this.timer = this.drawer.querySelector('[data-cart-timer]');

            // Re-bind close button
            if (this.closeBtn) {
              this.closeBtn.addEventListener('click', () => this.close());
            }

            // Re-bind quantity and remove buttons
            this.drawer.querySelectorAll('[data-qty-increase]').forEach((btn) => {
              btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyIncrease, 1));
            });

            this.drawer.querySelectorAll('[data-qty-decrease]').forEach((btn) => {
              btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyDecrease, -1));
            });

            this.drawer.querySelectorAll('[data-remove-item]').forEach((btn) => {
              btn.addEventListener('click', () => this.removeItem(btn.dataset.removeItem));
            });

            // Re-bind suggestion buttons
            this.bindSuggestionButtons();

            // Update free shipping progress after reloading drawer
            this.updateFreeShippingProgress();

            // Open drawer if requested
            if (shouldOpen) {
              this.open();
            }
          }
        }
      } catch (error) {
        console.error('Error reloading cart drawer:', error);
      }
    }
  }

  // Cart Suggestions Panel class
  class CartSuggestions {
    constructor() {
      this.panel = document.querySelector('[data-cart-suggestions]');
      this.toggleBtn = document.querySelector('[data-suggestions-toggle]');
      this.reopenBtn = document.querySelector('[data-suggestions-reopen]');
      this.cartDrawer = document.querySelector('[data-cart-drawer]');

      if (this.panel && this.toggleBtn) {
        this.init();
      }
    }

    init() {
      this.bindEvents();
      this.updateCartDrawerState();
      this.bindAddToCartForms();
    }

    bindEvents() {
      this.toggleBtn.addEventListener('click', () => {
        this.toggle();
        this.updateCartDrawerState();
      });

      if (this.reopenBtn) {
        this.reopenBtn.addEventListener('click', () => {
          this.show();
          this.updateCartDrawerState();
        });
      }
    }

    bindAddToCartForms() {
      const forms = this.panel.querySelectorAll('.cart-suggestions__form');
      forms.forEach((form) => {
        form.addEventListener('submit', (e) => this.handleAddToCart(e));
      });
    }

    async handleAddToCart(e) {
      e.preventDefault();

      const form = e.target;
      const submitBtn = form.querySelector('.cart-suggestions__add-to-cart');
      const formData = new FormData(form);

      // Disable button during request
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.5';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: 1,
          }),
        });

        if (response.ok) {
          // Trigger cart update event
          document.dispatchEvent(new CustomEvent('cart:updated'));

          // Open cart drawer to show the added product
          const cartDrawerInstance = window.cartDrawerInstance;
          if (cartDrawerInstance) {
            cartDrawerInstance.open();
          }
        } else {
          console.error('Error adding to cart:', await response.text());
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      } finally {
        // Re-enable button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
        }
      }
    }

    updateCartDrawerState() {
      if (this.cartDrawer) {
        if (this.panel.classList.contains('is-hidden')) {
          this.cartDrawer.classList.add('show-suggestions-toggle');
        } else {
          this.cartDrawer.classList.remove('show-suggestions-toggle');
        }
      }
    }

    toggle() {
      this.panel.classList.toggle('is-hidden');
    }

    show() {
      this.panel.classList.remove('is-hidden');
    }

    hide() {
      this.panel.classList.add('is-hidden');
    }
  }

  // Mobile Suggestions Carousel class
  class MobileSuggestionsCarousel {
    constructor() {
      this.carousel = document.querySelector('[data-suggestions-carousel]');
      this.track = document.querySelector('[data-suggestions-track]');
      this.dotsContainer = document.querySelector('[data-suggestions-dots]');

      if (!this.carousel || !this.track) {
        return;
      }

      this.items = Array.from(this.track.querySelectorAll('.cart-drawer__mobile-suggestion-item'));
      this.currentIndex = 0;
      this.autoPlayInterval = null;

      if (this.items.length > 0) {
        this.init();
      }
    }

    init() {
      this.createDots();
      this.bindEvents();
      this.bindAddToCartForms();
      this.startAutoPlay();
    }

    createDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.innerHTML = '';
      this.items.forEach((_, index) => {
        const dot = document.createElement('div');
        dot.classList.add('cart-drawer__mobile-suggestions-dot');
        if (index === 0) {
          dot.classList.add('active');
        }
        dot.addEventListener('click', () => {
          this.goToSlide(index);
          this.resetAutoPlay();
        });
        this.dotsContainer.appendChild(dot);
      });
      this.dots = Array.from(this.dotsContainer.querySelectorAll('.cart-drawer__mobile-suggestions-dot'));
    }

    bindEvents() {
      // Touch/swipe support
      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      this.carousel.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        this.stopAutoPlay();
      });

      this.carousel.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
      });

      this.carousel.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;

        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
        this.resetAutoPlay();
      });

      // Mouse drag support for desktop
      this.carousel.addEventListener('mousedown', (e) => {
        startX = e.clientX;
        isDragging = true;
        this.stopAutoPlay();
      });

      this.carousel.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        currentX = e.clientX;
      });

      this.carousel.addEventListener('mouseup', () => {
        if (!isDragging) return;
        isDragging = false;

        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
        this.resetAutoPlay();
      });

      this.carousel.addEventListener('mouseleave', () => {
        isDragging = false;
      });
    }

    bindAddToCartForms() {
      const forms = this.track.querySelectorAll('.cart-drawer__mobile-suggestion-form');
      forms.forEach((form) => {
        form.addEventListener('submit', (e) => this.handleAddToCart(e));
      });
    }

    async handleAddToCart(e) {
      e.preventDefault();

      const form = e.target;
      const submitBtn = form.querySelector('.cart-drawer__mobile-suggestion-add');
      const formData = new FormData(form);

      // Disable button during request
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.5';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: 1,
          }),
        });

        if (response.ok) {
          // Trigger cart update event
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } else {
          console.error('Error adding to cart:', await response.text());
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      } finally {
        // Re-enable button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
        }
      }
    }

    goToSlide(index) {
      this.currentIndex = index;
      const offset = -index * 100;
      this.track.style.transform = `translateX(${offset}%)`;
      this.updateDots();
    }

    next() {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      this.goToSlide(this.currentIndex);
    }

    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
      this.goToSlide(this.currentIndex);
    }

    updateDots() {
      if (!this.dots) return;
      this.dots.forEach((dot, index) => {
        if (index === this.currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    startAutoPlay() {
      this.autoPlayInterval = setInterval(() => {
        this.next();
      }, 5000); // Change slide every 5 seconds
    }

    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    }

    resetAutoPlay() {
      this.stopAutoPlay();
      this.startAutoPlay();
    }
  }

  // Initialize cart drawer and suggestions when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    window.cartDrawerInstance = new CartDrawer();
    new CartSuggestions();
    new MobileSuggestionsCarousel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroBannerLight {
    constructor() {
      this.heroImageContainer = document.querySelector('.hero-banner__image');
      if (this.heroImageContainer) {
        this.init();
      }
    }

    init() {
      // Light effect on mousemove
      this.heroImageContainer.addEventListener('mousemove', (e) => {
        const rect = this.heroImageContainer.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Update light position
        this.heroImageContainer.style.setProperty('--light-x', `${x}px`);
        this.heroImageContainer.style.setProperty('--light-y', `${y}px`);
        this.heroImageContainer.classList.add('light-active');
      });

      this.heroImageContainer.addEventListener('mouseleave', () => {
        this.heroImageContainer.classList.remove('light-active');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new HeroBannerLight();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');

    // Ouvrir le premier accordéon par défaut
    if (accordionTriggers.length > 0) {
      const firstTrigger = accordionTriggers[0];
      const firstTriggerId = firstTrigger.getAttribute('data-accordion-trigger');
      const firstContent = document.querySelector(`[data-accordion-content="${firstTriggerId}"]`);

      if (firstContent) {
        firstContent.classList.add('open');
        firstTrigger.classList.add('active');
      }
    }

    accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function () {
        const triggerId = this.getAttribute('data-accordion-trigger');
        const content = document.querySelector(`[data-accordion-content="${triggerId}"]`);
        const isOpen = content.classList.contains('open');

        // Toggle current accordion only
        if (isOpen) {
          content.classList.remove('open');
          this.classList.remove('active');
        } else {
          content.classList.add('open');
          this.classList.add('active');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-carousel"] && !Shopify.designMode) return;
  try {
    
  class PartnerCarousel {
    constructor(element) {
      this.track = element.querySelector('[data-carousel]');
      if (!this.track) return;

      this.position = 0;
      this.speed = this.getSpeed();
      this.animationId = null;
      this.trackWidth = 0;

      this.init();
    }

    getSpeed() {
      // Reduce speed on mobile devices
      const isMobile = window.innerWidth <= 768;
      return isMobile ? 0.25 : 0.5; // 0.25px/frame on mobile, 0.5px/frame on desktop
    }

    init() {
      // Calculate the width of the original items (not including clones)
      this.calculateTrackWidth();

      // Start animation
      this.animate();

      // Recalculate on window resize
      window.addEventListener('resize', () => {
        this.calculateTrackWidth();
        this.speed = this.getSpeed(); // Update speed on resize
      });
    }

    calculateTrackWidth() {
      const items = this.track.querySelectorAll('.partner-carousel__item:not(.partner-carousel__item--clone)');
      let totalWidth = 0;

      items.forEach((item, index) => {
        totalWidth += item.offsetWidth;
        // Add gap width except for the last item
        if (index < items.length - 1) {
          const gap = parseFloat(getComputedStyle(this.track).gap) || 144;
          totalWidth += gap;
        }
      });

      // Add one more gap for the space between last original and first clone
      const gap = parseFloat(getComputedStyle(this.track).gap) || 144;
      totalWidth += gap;

      this.trackWidth = totalWidth;
    }

    animate() {
      this.position -= this.speed;

      // Reset position when we've scrolled through all original items
      if (Math.abs(this.position) >= this.trackWidth) {
        this.position = 0;
      }

      this.track.style.transform = `translateX(${this.position}px)`;

      this.animationId = requestAnimationFrame(() => this.animate());
    }

    destroy() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
    }
  }

  // Initialize all carousels on the page
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.partner-carousel');
    carousels.forEach(carousel => new PartnerCarousel(carousel));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"] && !Shopify.designMode) return;
  try {
    
  class Product3DCard {
    constructor() {
      this.card = document.querySelector('[data-card]');
      if (!this.card) return;

      this.rotateX = 0;
      this.rotateY = 0;
      this.isDragging = false;
      this.startX = 0;
      this.startY = 0;
      this.currentX = 0;
      this.currentY = 0;

      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      // Mouse events
      this.card.addEventListener('mousedown', this.handleMouseDown.bind(this));
      document.addEventListener('mousemove', this.handleMouseMove.bind(this));
      document.addEventListener('mouseup', this.handleMouseUp.bind(this));

      // Touch events
      this.card.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
      document.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
      document.addEventListener('touchend', this.handleTouchEnd.bind(this));
    }

    handleMouseDown(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.card.style.transition = 'none';
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;

      const deltaX = e.clientX - this.startX;
      const deltaY = e.clientY - this.startY;

      this.rotateY += deltaX * 0.5;
      this.rotateX -= deltaY * 0.5;

      // Limit rotation
      this.rotateX = Math.max(-90, Math.min(90, this.rotateX));

      this.updateTransform();

      this.startX = e.clientX;
      this.startY = e.clientY;
    }

    handleMouseUp() {
      this.isDragging = false;
      this.card.style.transition = 'transform 0.6s cubic-bezier(0.23, 1, 0.32, 1)';
    }

    handleTouchStart(e) {
      if (e.touches.length !== 1) return;

      this.isDragging = true;
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
      this.card.style.transition = 'none';
      e.preventDefault();
    }

    handleTouchMove(e) {
      if (!this.isDragging || e.touches.length !== 1) return;

      const deltaX = e.touches[0].clientX - this.startX;
      const deltaY = e.touches[0].clientY - this.startY;

      this.rotateY += deltaX * 0.5;
      this.rotateX -= deltaY * 0.5;

      // Limit rotation
      this.rotateX = Math.max(-90, Math.min(90, this.rotateX));

      this.updateTransform();

      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;

      e.preventDefault();
    }

    handleTouchEnd() {
      this.isDragging = false;
      this.card.style.transition = 'transform 0.6s cubic-bezier(0.23, 1, 0.32, 1)';
    }

    updateTransform() {
      this.card.style.transform = `rotateX(${this.rotateX}deg) rotateY(${this.rotateY}deg)`;
    }
  }

  // Initialize when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new Product3DCard();
    });
  } else {
    new Product3DCard();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    // Load Lottie library
    const lottieScript = document.createElement('script');
    lottieScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
    lottieScript.onload = function () {
      // Initialize Lottie animation
      const lottieContainer = document.querySelector('[data-lottie-chevron]');
      if (lottieContainer && window.lottie) {
        const animationPath = lottieContainer.getAttribute('data-lottie-path');
        window.lottie.loadAnimation({
          container: lottieContainer,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: animationPath,
        });
      }
    };
    document.head.appendChild(lottieScript);

    // Image Gallery (Desktop Slider)
    const gallery = document.querySelector('.product-page__gallery');
    if (gallery) {
      const track = gallery.querySelector('[data-desktop-slider-track]');
      const slides = Array.from(gallery.querySelectorAll('.product-page__slide'));
      const prevButton = gallery.querySelector('.product-page__chevron--prev');
      const nextButton = gallery.querySelector('.product-page__chevron--next');
      const thumbnails = gallery.querySelectorAll('.product-page__thumbnail');

      if (slides.length > 1) {
        let currentSlide = 0;

        function updateThumbnails(index) {
          thumbnails.forEach((thumb, i) => {
            if (i === index) {
              thumb.classList.add('product-page__thumbnail--active');
            } else {
              thumb.classList.remove('product-page__thumbnail--active');
            }
          });
        }

        function updateSlider() {
          const offset = -currentSlide * 100;
          track.style.transform = `translateX(${offset}%)`;
          updateThumbnails(currentSlide);
        }

        function goToSlide(index) {
          currentSlide = Math.max(0, Math.min(index, slides.length - 1));
          updateSlider();
        }

        function nextSlide() {
          if (currentSlide < slides.length - 1) {
            goToSlide(currentSlide + 1);
          } else {
            goToSlide(0); // Loop back to start
          }
        }

        function prevSlide() {
          if (currentSlide > 0) {
            goToSlide(currentSlide - 1);
          } else {
            goToSlide(slides.length - 1); // Loop to end
          }
        }

        if (nextButton) {
          nextButton.addEventListener('click', nextSlide);
        }

        if (prevButton) {
          prevButton.addEventListener('click', prevSlide);
        }

        // Thumbnail click handlers
        thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            if (index !== currentSlide) {
              goToSlide(index);
            }
          });
        });
      }
    }

    // Mobile Slider
    const mobileSlider = document.querySelector('[data-mobile-slider]');
    if (mobileSlider) {
      const track = mobileSlider.querySelector('[data-slider-track]');
      const slides = Array.from(mobileSlider.querySelectorAll('.product-page__mobile-slide'));
      const progressBar = mobileSlider.querySelector('[data-mobile-progress-bar]');

      let currentSlide = 0;
      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      function updateProgressBar() {
        if (progressBar && slides.length > 1) {
          // Calculate progress: starts partially filled and reaches 100% at the last slide
          // Example: 3 images -> 33%, 66%, 100% | 2 images -> 50%, 100%
          const progress = ((currentSlide + 1) / slides.length) * 100;
          progressBar.style.width = `${progress}%`;
        }
      }

      function updateSlider() {
        const offset = -currentSlide * 100;
        track.style.transform = `translateX(${offset}%)`;
        updateProgressBar();
      }

      function goToSlide(index) {
        currentSlide = Math.max(0, Math.min(index, slides.length - 1));
        updateSlider();
      }

      function nextSlide() {
        if (currentSlide < slides.length - 1) {
          goToSlide(currentSlide + 1);
        }
      }

      function prevSlide() {
        if (currentSlide > 0) {
          goToSlide(currentSlide - 1);
        }
      }

      // Initialize progress bar
      updateProgressBar();

      // Touch/drag events
      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        track.style.transition = 'none';
      });

      track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
        const diff = currentX - startX;
        const offset = -currentSlide * 100 + (diff / track.offsetWidth) * 100;
        track.style.transform = `translateX(${offset}%)`;
      });

      track.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = 'transform 0.3s ease';

        const diff = currentX - startX;
        const threshold = track.offsetWidth * 0.2;

        if (diff > threshold && currentSlide > 0) {
          prevSlide();
        } else if (diff < -threshold && currentSlide < slides.length - 1) {
          nextSlide();
        } else {
          updateSlider();
        }
      });

      // Mouse drag for desktop testing
      track.addEventListener('mousedown', (e) => {
        startX = e.clientX;
        isDragging = true;
        track.style.transition = 'none';
        track.style.cursor = 'grabbing';
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        currentX = e.clientX;
        const diff = currentX - startX;
        const offset = -currentSlide * 100 + (diff / track.offsetWidth) * 100;
        track.style.transform = `translateX(${offset}%)`;
      });

      document.addEventListener('mouseup', () => {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = 'transform 0.3s ease';
        track.style.cursor = 'grab';

        const diff = currentX - startX;
        const threshold = track.offsetWidth * 0.2;

        if (diff > threshold && currentSlide > 0) {
          prevSlide();
        } else if (diff < -threshold && currentSlide < slides.length - 1) {
          nextSlide();
        } else {
          updateSlider();
        }
      });

      // Initial cursor style
      track.style.cursor = 'grab';
    }

    // Scroll State Management (disabled on mobile)
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const productRight = document.querySelector('[data-product-right]');
    const initialState = document.querySelector('[data-initial-state]');
    const scrolledState = document.querySelector('[data-scrolled-state]');
    const scrollToggle = document.querySelector('[data-scroll-toggle]');

    if (productRight && initialState && scrolledState && !isMobile) {
      let currentState = 0; // 0 = initial, 1 = step1 (40px), 2 = step2 (330px + blur), 3 = fully visible, 4 = page scroll locked
      let isTransitioning = false;
      let wheelDelta = 0;
      let wheelThreshold = 10;

      function updateToggleButton() {
        if (scrollToggle) {
          if (currentState >= 1) {
            scrollToggle.classList.add('rotated');
          } else {
            scrollToggle.classList.remove('rotated');
          }
        }
      }

      function switchToState(newState) {
        if (isTransitioning || currentState === newState) return;

        isTransitioning = true;
        currentState = newState;

        // Remove all state classes
        scrolledState.classList.remove('visible-step1', 'visible-step2', 'visible-step3');
        initialState.classList.remove('hidden-step1', 'hidden-step2', 'hidden-step3');

        // Apply new state classes
        if (currentState === 0) {
          // Initial state - everything reset
          initialState.classList.remove('hidden-step1', 'hidden-step2', 'hidden-step3');
          document.body.classList.remove('scroll-locked');
        } else if (currentState === 1) {
          // Step 1: 40px visible, no blur
          scrolledState.classList.add('visible-step1');
          document.body.classList.add('scroll-locked');
        } else if (currentState === 2) {
          // Step 2: 330px visible + blur
          scrolledState.classList.add('visible-step2');
          initialState.classList.add('hidden-step2');
          document.body.classList.add('scroll-locked');
        } else if (currentState === 3) {
          // Step 3: Fully visible
          scrolledState.classList.add('visible-step3');
          initialState.classList.add('hidden-step3');
          document.body.classList.add('scroll-locked');
        } else if (currentState === 4) {
          // Step 4: Same visual as step 3, but unlocks page scroll
          scrolledState.classList.add('visible-step3');
          initialState.classList.add('hidden-step3');
          document.body.classList.remove('scroll-locked');
        }

        updateToggleButton();
        productRight.scrollTop = 0;

        isTransitioning = false;
      }

      function nextState() {
        if (currentState < 4) {
          switchToState(currentState + 1);
        }
      }

      function prevState() {
        if (currentState > 0) {
          switchToState(currentState - 1);
        }
      }

      // Handle wheel/scroll events on window
      window.addEventListener(
        'wheel',
        function (e) {
          if (currentState === 0) {
            // On initial state, detect scroll down to go to step 1
            if (e.deltaY > 0) {
              e.preventDefault();
              wheelDelta += Math.abs(e.deltaY);

              if (wheelDelta >= wheelThreshold) {
                wheelDelta = 0;
                nextState();
              }
            } else {
              wheelDelta = 0;
            }
          } else if (currentState >= 1 && currentState < 3) {
            // On intermediate states, scroll down to next step
            if (e.deltaY > 0) {
              e.preventDefault();
              wheelDelta += Math.abs(e.deltaY);

              if (wheelDelta >= wheelThreshold) {
                wheelDelta = 0;
                nextState();
              }
            } else if (e.deltaY < 0) {
              // Scroll up to previous step
              e.preventDefault();
              wheelDelta += Math.abs(e.deltaY);

              if (wheelDelta >= wheelThreshold) {
                wheelDelta = 0;
                prevState();
              }
            }
          } else if (currentState === 3) {
            // On state 3, allow scroll in scrolled-state content or go to next state
            const scrolledToTop = productRight.scrollTop <= 0;
            const scrolledToBottom =
              productRight.scrollTop + productRight.clientHeight >= productRight.scrollHeight - 10;

            if (scrolledToTop && e.deltaY < 0) {
              e.preventDefault();
              wheelDelta += Math.abs(e.deltaY);

              if (wheelDelta >= wheelThreshold) {
                wheelDelta = 0;
                prevState();
              }
            } else if (scrolledToBottom && e.deltaY > 0) {
              // At bottom, scroll down to unlock page scroll
              e.preventDefault();
              wheelDelta += Math.abs(e.deltaY);

              if (wheelDelta >= wheelThreshold) {
                wheelDelta = 0;
                nextState();
              }
            } else {
              wheelDelta = 0;
            }
          } else if (currentState === 4) {
            // On state 4, page scroll is unlocked
            // Detect scroll up to go back to state 3
            if (e.deltaY < 0 && window.scrollY <= 0) {
              e.preventDefault();
              wheelDelta += Math.abs(e.deltaY);

              if (wheelDelta >= wheelThreshold) {
                wheelDelta = 0;
                prevState();
              }
            } else {
              wheelDelta = 0;
            }
          }
        },
        { passive: false }
      );

      // Scroll toggle button click handler
      if (scrollToggle) {
        scrollToggle.addEventListener('click', function () {
          if (currentState === 0) {
            switchToState(4); // Jump directly to fully visible with unlocked scroll
          } else {
            switchToState(0); // Return to initial
          }
        });
      }

      // More info button click handler
      const moreInfoBtn = document.querySelector('.product-page__more-info');
      if (moreInfoBtn) {
        moreInfoBtn.addEventListener('click', function () {
          switchToState(4); // Jump directly to fully visible with unlocked scroll
        });
      }
    }

    // Add to Cart AJAX functionality
    const productForms = document.querySelectorAll(
      '.product-page__form, .product-page__form-compact, .product-page__form-mobile'
    );

    productForms.forEach((form) => {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        const formData = new FormData(form);
        const variantId = formData.get('id');

        const submitButton = form.querySelector('button[type="submit"]');
        const originalText = submitButton ? submitButton.querySelector('.button__text').textContent : '';

        // Disable button during submission
        if (submitButton) {
          submitButton.disabled = true;
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
            }),
          });

          if (response.ok) {
            const data = await response.json();

            // Show success feedback
            if (submitButton) {
              submitButton.querySelector('.button__text').textContent = 'Ajouté';
              setTimeout(() => {
                submitButton.querySelector('.button__text').textContent = originalText;
                submitButton.disabled = false;
              }, 2000);
            }

            // Fetch updated cart data to get total item count
            fetch('/cart.js')
              .then((res) => res.json())
              .then((cart) => {
                // Update cart icon count if it exists
                const cartCountElement = document.querySelector('[data-cart-count]');
                if (cartCountElement) {
                  cartCountElement.textContent = cart.item_count;
                  cartCountElement.setAttribute('data-cart-count', cart.item_count);
                }

                // Dispatch cart updated event to trigger drawer reload and open it
                document.dispatchEvent(
                  new CustomEvent('cart:updated', {
                    detail: {
                      ...data,
                      openDrawer: true,
                    },
                  })
                );
              });
          } else {
            const errorData = await response.json();
            console.error('Cart add error:', errorData);
            throw new Error(errorData.description || 'Failed to add to cart');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);

          // Show error feedback
          if (submitButton) {
            submitButton.querySelector('.button__text').textContent = 'Erreur';
            setTimeout(() => {
              submitButton.querySelector('.button__text').textContent = originalText;
              submitButton.disabled = false;
            }, 2000);
          }
        }
      });
    });

    // Accordion Functionality
    const accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');

    // Separate desktop and mobile accordions
    const desktopAccordions = document.querySelector('.product-page__accordions');
    const mobileAccordions = document.querySelector('.product-page__accordions--mobile');

    // Ouvrir le premier accordéon par défaut (desktop)
    if (desktopAccordions) {
      const firstDesktopTrigger = desktopAccordions.querySelector('[data-accordion-trigger]');
      if (firstDesktopTrigger) {
        const firstContent = firstDesktopTrigger.parentElement.querySelector('[data-accordion-content]');
        if (firstContent) {
          firstContent.classList.add('open');
          firstDesktopTrigger.classList.add('active');
        }
      }
    }

    // Ouvrir le premier accordéon par défaut (mobile)
    if (mobileAccordions) {
      const firstMobileTrigger = mobileAccordions.querySelector('[data-accordion-trigger]');
      if (firstMobileTrigger) {
        const firstContent = firstMobileTrigger.parentElement.querySelector('[data-accordion-content]');
        if (firstContent) {
          firstContent.classList.add('open');
          firstMobileTrigger.classList.add('active');
        }
      }
    }

    accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function () {
        const content = this.parentElement.querySelector('[data-accordion-content]');
        const isOpen = content.classList.contains('open');

        // Determine if we're in desktop or mobile accordions
        const isDesktop = this.closest('.product-page__accordions');
        const isMobile = this.closest('.product-page__accordions--mobile');

        // Close all accordions in the same group
        if (isDesktop) {
          desktopAccordions.querySelectorAll('[data-accordion-content]').forEach((item) => {
            item.classList.remove('open');
          });
          desktopAccordions.querySelectorAll('[data-accordion-trigger]').forEach((item) => {
            item.classList.remove('active');
          });
        } else if (isMobile) {
          mobileAccordions.querySelectorAll('[data-accordion-content]').forEach((item) => {
            item.classList.remove('open');
          });
          mobileAccordions.querySelectorAll('[data-accordion-trigger]').forEach((item) => {
            item.classList.remove('active');
          });
        }

        // Toggle current accordion
        if (!isOpen) {
          content.classList.add('open');
          this.classList.add('active');
        }
      });
    });
  })();

  // Add to cart via AJAX
  (function () {
    const form = document.querySelector('.product-page__form');

    if (form) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        const formData = new FormData(this);
        const submitButton = this.querySelector('button[type="submit"]');
        const originalText = submitButton.textContent;

        // Disable button during submission
        submitButton.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: formData.get('id'),
              quantity: 1,
            }),
          });

          if (response.ok) {
            const data = await response.json();

            // Update cart count in header
            const cartCount = document.querySelector('[data-cart-count]');
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();

            if (cartCount) {
              cartCount.textContent = cart.item_count;
              if (cart.item_count > 0) {
                cartCount.style.display = 'flex';
              }
            }

            // Dispatch custom event to update cart drawer and open it
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                detail: {
                  ...cart,
                  openDrawer: true,
                },
              })
            );

            // Show success feedback
            submitButton.textContent = 'Ajouté';

            // Reset button after 2 seconds
            setTimeout(() => {
              submitButton.disabled = false;
              submitButton.textContent = originalText;
            }, 2000);
          } else {
            throw new Error('Failed to add to cart');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          submitButton.textContent = 'Erreur';

          setTimeout(() => {
            submitButton.disabled = false;
            submitButton.textContent = originalText;
          }, 2000);
        }
      });
    }
  })();

  // Image Modal
  (function () {
    const modal = document.querySelector('[data-image-modal]');
    const modalImg = document.querySelector('[data-modal-img]');
    const modalClose = document.querySelector('[data-modal-close]');
    const modalBackdrop = document.querySelector('[data-modal-backdrop]');
    const modalPrev = document.querySelector('[data-modal-prev]');
    const modalNext = document.querySelector('[data-modal-next]');
    const images = document.querySelectorAll('.product-page__image');
    const mobileSlideImages = document.querySelectorAll('.product-page__mobile-slide-image');

    if (!modal || !modalImg) return;

    // Combine all images into a single array
    const allImages = [...images, ...mobileSlideImages];
    let currentIndex = 0;

    // Function to update chevron visibility
    function updateChevrons() {
      if (!modalPrev || !modalNext) return;

      if (currentIndex === 0) {
        modalPrev.classList.add('hidden');
      } else {
        modalPrev.classList.remove('hidden');
      }

      if (currentIndex === allImages.length - 1) {
        modalNext.classList.add('hidden');
      } else {
        modalNext.classList.remove('hidden');
      }
    }

    // Function to show image at index
    function showImage(index) {
      if (index < 0 || index >= allImages.length) return;

      currentIndex = index;
      const img = allImages[index];
      const largeSrc = img.src.replace(/width=\d+/, 'width=2000');
      modalImg.src = largeSrc;
      modalImg.alt = img.alt || '';

      updateChevrons();
    }

    // Function to open modal
    function openModal(imageSrc, imageAlt, index) {
      currentIndex = index;
      modalImg.src = imageSrc;
      modalImg.alt = imageAlt || '';
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      updateChevrons();
    }

    // Function to close modal
    function closeModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }

    // Add click listeners to all images
    allImages.forEach((img, index) => {
      img.style.cursor = 'pointer';
      img.addEventListener('click', function () {
        const largeSrc = this.src.replace(/width=\d+/, 'width=2000');
        openModal(largeSrc, this.alt, index);
      });
    });

    // Previous image
    if (modalPrev) {
      modalPrev.addEventListener('click', function () {
        if (currentIndex > 0) {
          showImage(currentIndex - 1);
        }
      });
    }

    // Next image
    if (modalNext) {
      modalNext.addEventListener('click', function () {
        if (currentIndex < allImages.length - 1) {
          showImage(currentIndex + 1);
        }
      });
    }

    // Close modal on close button click
    if (modalClose) {
      modalClose.addEventListener('click', closeModal);
    }

    // Close modal on backdrop click
    if (modalBackdrop) {
      modalBackdrop.addEventListener('click', closeModal);
    }

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('active')) return;

      if (e.key === 'Escape') {
        closeModal();
      } else if (e.key === 'ArrowLeft' && !modalImg.classList.contains('zoomed')) {
        if (currentIndex > 0) {
          showImage(currentIndex - 1);
        }
      } else if (e.key === 'ArrowRight' && !modalImg.classList.contains('zoomed')) {
        if (currentIndex < allImages.length - 1) {
          showImage(currentIndex + 1);
        }
      }
    });

    // Zoom functionality
    let isZoomed = false;
    const zoomScale = 1.5;
    const modalContent = document.querySelector('.product-page__image-modal-content');

    // Toggle zoom on image click
    modalImg.addEventListener('click', function (e) {
      e.stopPropagation();

      if (!isZoomed) {
        // Zoom in
        isZoomed = true;
        this.classList.add('zoomed');

        // Calculate the click position relative to the image
        const rect = this.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Calculate percentage position
        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;

        // Set transform origin to click position
        this.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        this.style.transform = `scale(${zoomScale})`;
      } else {
        // Zoom out
        resetZoom();
      }
    });

    // Reset zoom function
    function resetZoom() {
      isZoomed = false;
      modalImg.classList.remove('zoomed');
      modalImg.style.transform = 'scale(1)';
      modalImg.style.transformOrigin = 'center center';
    }

    // Mouse move to pan when zoomed (no click required)
    modalContent.addEventListener('mousemove', function (e) {
      if (!isZoomed) return;

      const rect = modalImg.getBoundingClientRect();
      const modalRect = modalContent.getBoundingClientRect();

      // Calculate mouse position relative to modal center
      const mouseX = e.clientX - modalRect.left - modalRect.width / 2;
      const mouseY = e.clientY - modalRect.top - modalRect.height / 2;

      // Calculate the movement range based on zoomed image size
      const imageWidth = rect.width;
      const imageHeight = rect.height;
      const modalWidth = modalRect.width;
      const modalHeight = modalRect.height;

      // Calculate maximum translation (how far the image can move)
      const maxTranslateX = (imageWidth - modalWidth) / 2;
      const maxTranslateY = (imageHeight - modalHeight) / 2;

      // Calculate translation based on mouse position
      // Map mouse position to translation range
      const translateX = -(mouseX / (modalWidth / 2)) * maxTranslateX;
      const translateY = -(mouseY / (modalHeight / 2)) * maxTranslateY;

      // Apply transform
      modalImg.style.transform = `scale(${zoomScale}) translate(${translateX / zoomScale}px, ${
        translateY / zoomScale
      }px)`;
    });

    // Reset zoom when changing images
    const originalShowImage = showImage;
    showImage = function (index) {
      resetZoom();
      originalShowImage(index);
    };

    // Reset zoom when closing modal
    const originalCloseModal = closeModal;
    closeModal = function () {
      resetZoom();
      originalCloseModal();
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
